<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22 12v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h7a1 1 0 1 1 0 2H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7a1 1 0 1 1 2 0M11 9a1 1 0 1 0-2 0v5a1 1 0 0 0 .2.6l.15.16A1 1 0 0 0 10 15h5a1 1 0 1 0 0-2h-2.59l9.3-9.3a1 1 0 1 0-1.42-1.4L11 11.58z"/></svg>
</template>
